import { render, staticRenderFns } from "./AllRootCategories.vue?vue&type=template&id=ca28f052&scoped=true"
import script from "./AllRootCategories.vue?vue&type=script&lang=js"
export * from "./AllRootCategories.vue?vue&type=script&lang=js"
import style0 from "./AllRootCategories.vue?vue&type=style&index=0&id=ca28f052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca28f052",
  null
  
)

export default component.exports